/**
 * Aufrufe des Tokenmanagements -- die hinterlegten Zugaenge zu fremden
 * Diensten (F5-01).
 *
 * **Das Kennwort geht hinein und nie wieder heraus.** Es gibt keinen Weg, es
 * zu lesen -- auch keinen maskierten: Ein maskierter Wert in der Antwort ist
 * ein Feld, das ein Client zurueckschicken kann, und dann steht irgendwann
 * `********` als Kennwort in der Datenbank. Dass eines hinterlegt ist, sagt
 * `has_password`.
 *
 * Der Namensraum des Servers heisst `/backup/providers`, weil der Zugang zu
 * diesem Bestand gehoert. Die Maske heisst "Tokenmanagement", weil dort auch
 * der naechste Zugang stehen wird -- und weil der Anwender sie unter diesem
 * Namen sucht.
 */

import type { components } from '../../api/schema';
import { request } from '../../lib/apiClient';

export type BackupProvider = components['schemas']['BackupProviderRead'];
export type ProviderTestResult = components['schemas']['BackupProviderTestResult'];

export interface ProviderPayload {
  name: string;
  partner_name?: string;
  partner_id: string;
  api_user: string;
  password?: string;
  base_url?: string;
  is_active?: boolean;
}

export function fetchProviders(): Promise<BackupProvider[]> {
  return request<BackupProvider[]>('/backup/providers');
}

export function createProvider(payload: ProviderPayload): Promise<BackupProvider> {
  return request<BackupProvider>('/backup/providers', { method: 'POST', body: payload });
}

export function updateProvider(
  providerId: string,
  payload: Partial<ProviderPayload>,
): Promise<BackupProvider> {
  return request<BackupProvider>(`/backup/providers/${providerId}`, {
    method: 'PATCH',
    body: payload,
  });
}

export function deleteProvider(providerId: string): Promise<undefined> {
  return request<undefined>(`/backup/providers/${providerId}`, { method: 'DELETE' });
}

/**
 * Die Verbindungspruefung.
 *
 * Sie meldet ein Ergebnis und keinen Fehler: `ok: false` mit einer Meldung
 * statt eines Fehlerstatus. Eine gescheiterte Pruefung ist etwas, das der
 * Anwender wissen will -- keine Stoerung des Aufrufs.
 */
export function testProvider(providerId: string): Promise<ProviderTestResult> {
  return request<ProviderTestResult>(`/backup/providers/${providerId}/test`, { method: 'POST' });
}
